import { BookingTypeSubmitRules } from "../../../../utils/globalEnums"

export function bookingTypeIsVendorAccountSeachable(bookingType)
{
  const submitType = bookingType?.submitType;
  return submitType === BookingTypeSubmitRules.sendThroughWorkday || submitType === BookingTypeSubmitRules.sendThroughIntacct ||
    submitType === BookingTypeSubmitRules.sendThroughQuickbooks || submitType === BookingTypeSubmitRules.sendThroughReliable;
}

export function bookingTypeIsFacilitySeachable(bookingType) {
  const submitType = bookingType?.submitType;
  return submitType === BookingTypeSubmitRules.sendThroughQuickbooks;
}